module.exports = __webpack_public_path__ + "media/images/logos/University-of-Exeter-c4673f9b290eff782ca447718b93c304.svg";